export const PROJECT_BRANDS = Object.freeze({
    reverse: 'ReverseHealth',
    muscleCharge: 'MuscleCharge',
});
export function getAppDomain(brand, publicAppDomains) {
    if (!brand) {
        throw new Error('Brand is required to get app domain');
    }
    if (!publicAppDomains || typeof publicAppDomains !== 'object') {
        throw new Error('publicAppDomains configuration is required');
    }
    return publicAppDomains[brand];
}
export function openAppSubscriptionManagement(brand, publicAppDomains) {
    const appDomain = getAppDomain(brand, publicAppDomains);
    if (!appDomain) {
        throw new Error(`No app domain configured for brand: ${brand}`);
    }
    const managementUrl = `${appDomain}/profile/settings?action=manage-subscription`;
    window.open(managementUrl, '_blank', 'noopener,noreferrer');
}
// To Do: Update this with env variables or a config file as needed
export const getBaseUrlByBrand = (brand) => {
    const baseUrlMap = {
        [PROJECT_BRANDS.reverse]: 'https://reverse.health/',
        [PROJECT_BRANDS.muscleCharge]: 'https://www.musclecharge.app/',
    };
    return baseUrlMap[brand] || 'https://reverse.health/';
};
